'use client'

import { cx } from 'class-variance-authority'
import { UserIcon } from '@phosphor-icons/react/dist/ssr/User'

type UserCardProps = {
  name: string
  description?: string
  title?: string
  className?: string
  children?: React.ReactNode
}

export const UserCard = ({
  name,
  description,
  title,
  className,
  children,
}: UserCardProps) => {
  return (
    <div
      className={cx(
        'relative flex flex-col items-center overflow-y-visible rounded-xl bg-white shadow-md',
        className,
      )}
      title={title}
    >
      <div className="h-24 w-full rounded-t-xl bg-primary-500" />
      <div className="top-16 z-0 flex flex-col items-center gap-4 px-5 py-5">
        <div className="-mt-12 rounded-full bg-white p-4">
          <UserIcon className="size-8 text-black" weight="duotone" />
        </div>

        {(name || description) && (
          <div className="flex flex-col items-center">
            <p className="font-Roboto-md text-black">{name}</p>
            <p className="text-xs font-medium text-gray-500">{description}</p>
          </div>
        )}

        <div className="flex items-center gap-3">{children}</div>
      </div>
    </div>
  )
}
